import { useLayoutEffect } from "react";
import classNames from "classnames";
import useAxios from "axios-hooks";
import { useParams } from "react-router-dom";

import Api from "../../api";
import SeoBlock from "../../components/seo_block/SeoBlock";
import { Spinner } from "../../components";
import { useCorrectCustomers } from "../../hooks";
import { reloadPage } from "../../utils";

import styles from "./produce.module.scss";

const PageSingle = ({ contact }) => {
  useLayoutEffect(function redirectToRubyPage() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      // window.location.replace(`http://localhost:3001${window.location.pathname}`);
    } else {
      window.history.pushState('service_react', '', window.location.pathname);
      // window.history.back();
      reloadPage();
    }
  });

  const [{ data }] = useAxios({ url: Api.page_produce });

  const correctCustomers = useCorrectCustomers(data?.customers);

  const page = data ? data.page : {};
  const seo = data ? data.seo : {};
  const contact_in = contact && contact.city_in;
  const h1Title = seo?.seo_h1 ? (
    <h1 className="h2-title">
      {seo.seo_h1.includes("#CITY_ROD#")
        ? seo.seo_h1.replace("#CITY_ROD#", contact_in)
        : seo.seo_h1}
    </h1>
  ) : (
    ""
  );

  return (
    <div className={classNames(
      // "pageAbout main-container",
    styles.ProducePage)}>
      <SeoBlock data={seo} contact={contact} />

      <Spinner />

      {/* <div className={classNames("page-header", styles.producePageHeader)}>
        <div className="holder wrap">
          {h1Title && h1Title}
          {page && page.title && (
            <h1 className={classNames("h2-title", styles.producePageHeaderTitle)} >
              {page.title}
            </h1>
          )}
        </div>
      </div>

      <div className="sections-list">
        {data?.produce_stages_first?.length > 0 && (
          <div>
            <Section className="section">
              <Stages
                list={data.produce_stages_first}
                title="Комплексность работы и практическая применимость её результатов для решения актуальных проблем. Вот ценность, которую мы несём производственным компаниям."
              />
            </Section>
          </div>
        )}

        <div>
          <Section className="section">
            {page?.headbody && (
              <div
                className={styles.produceSlidesText}
                dangerouslySetInnerHTML={{ __html: page.headbody }}
              />
            )}

            {data?.produce_slides.length > 0 && (
              <MainSlider slides={data.produce_slides} showBtn={false} />
            )}
          </Section>
        </div>
      </div>

      <div className="sections-list">
        {data?.produce_stages?.length > 0 && (
          <div>
            <Section className="section">
              <div className={styles.produceStagesWrap}>
                {data.produce_stages.map((item, index) => {
                  return (
                    <div className={styles.produceStages} key={index}>
                      <span className={styles.produceStagesPrior}>
                        {item.prior}
                      </span>
                      <div className={styles.produceStagesTitle}>
                        {item.title}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Section>
          </div>
        )}

        {correctCustomers?.length > 0 && (
          <div>
            <Section className="section">
              <Customers customers={correctCustomers} />
            </Section>
          </div>
        )}
      </div> */}
    </div>
  );
};

export default PageSingle;
